import React, { useEffect, useState } from 'react';
import 'components/campaign/campaignCreation/CreateCampaignStepTwo.scss';
import { connect } from 'react-redux';
import { ContinueWithBackAndTempSaveButtons } from 'components/base/BottomStepComponent';
import { useFormContext } from 'react-hook-form';
import { CREATION_STEP_TWO_CONFIG } from './StampCampaignCreationConfig';
import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';
import { useParams } from 'react-router-dom';
import StampTask from "assets/images/campaignStreamline/stamp_task.svg"
import { ActionType, APIStatus, CampaignType } from 'config/CustomEnums';
import PublishCampaignPrompt from 'components/campaign/campaignCreation/PublishCampaignPrompt';
import { scrollToAnchor } from 'components/campaignStreamline/CreateCampaignHandleError';


const mapPropsToState = (state) => ({
  anchorKey: state.campaignStreamline.anchorKey,
  sectionKey: state.campaignStreamline.sectionKey,
  createStatus: state.createCampaign.createStatus,
  formHasSubmitted: state.createCampaign.formHasSubmitted,
});

function CreateStampCampaignStepTwoV2({
  anchorKey,
  sectionKey,
  createStatus,
  formHasSubmitted,
  onStepChange,
  onSaveTemp,
}) {
  const params = useParams();
  const campaignId = params.id
  const isEditMode = !!campaignId
  const formContext = useFormContext();
  const [showPublishPrompt, setShowPublishPrompt] = useState(false);

  useEffect(() => {
    scrollToAnchor(anchorKey, sectionKey);
  }, [anchorKey, sectionKey]);

  useEffect(() => {
    if (createStatus === APIStatus.success && formHasSubmitted) {
      setShowPublishPrompt(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createStatus, formHasSubmitted]);

  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATION_STEP_TWO_CONFIG}
        inputWithImageConfig={{}}
        defaultImage={StampTask}
      />
      <ContinueWithBackAndTempSaveButtons
        backAction={() => {
          onStepChange(0);
        }}
        {...isEditMode ? {} : {
          saveTempText: "Save as draft",
          saveTempAction: () => {
            onSaveTemp && onSaveTemp(formContext)
          }
        }}
        continueAction={() => {
          onStepChange(2);
        }}
      />
      <PublishCampaignPrompt
        campaignId={campaignId}
        campaignType={CampaignType.stampCampaign}
        actionType={ActionType.save}
        show={showPublishPrompt}
        path={'/stamp_campaigns'}
      />
    </>
  );
}


export default connect(mapPropsToState)(CreateStampCampaignStepTwoV2);
